import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getBusinessWebsites(businessId, params = {}) {
  return axios.get(`/ajax/businesses/${businessId}/websites`, { params })
}
export function getWebsite(id) {
  return axios.get(`/ajax/websites/${id}`)
}
export function createWebsite(businessId, data) {
  return axios.post(`/ajax/businesses/${businessId}/websites`, data)
}
export function updateWebsite(id, data) {
  return axios.patch(`/ajax/websites/${id}`, data)
}
export function destroyWebsite(id) {
  return axios.delete(`/ajax/websites/${id}`)
}
export function importSitemap(websiteId, sitemapUrl) {
  return axios.post(`/ajax/websites/${websiteId}/import_sitemap`, { sitemap_url: sitemapUrl })
}
export function extractAllPages(websiteId) {
  return axios.post(`/ajax/websites/${websiteId}/extract_all_pages`)
}
export function enableGa(websiteId, analyticsPropertyId) {
  return axios.post(`/ajax/websites/${websiteId}/enable_ga`, { analytics_property_id: analyticsPropertyId })
}
export function enableGsc(websiteId, searchConsoleSiteId) {
  return axios.post(`/ajax/websites/${websiteId}/enable_gsc`, { search_console_site_id: searchConsoleSiteId })
}
